
const app = {
  state: {
    api_host: '',
    host: '',
    version: '',
    adSlots: [],
    activeStatus: [
      {
        label: '禁用',
        value: 0
      },
      {
        label: '启用',
        value: 1
      }
    ],
    publishStatus: [
      {
        label: '未发布',
        value: 0
      },
      {
        label: '已发布',
        value: 1
      }
    ],
    linkTypes: [
      {
        label: '小程序页面',
        value: 0
      },
      {
        label: '文章',
        value: 1
      },
      {
        label: '活动',
        value: 2
      },
      {
        label: '外部链接',
        value: 3
      }
    ],
    sexes: [
      {
        label: '未知',
        value: 0
      },
      {
        label: '男',
        value: 1
      },
      {
        label: '女',
        value: 2
      }
    ],
    consultantTypes: [
      {
        label: '线下',
        value: 0
      },
      {
        label: '线上',
        value: 1
      }
    ],
    orderAudits: [
      {
        label: '审核通过',
        value: true
      },
      {
        label: '审核失败',
        value: false
      }
    ],
    confirmFlag: [
      {
        label: '已确认',
        value: true
      },
      {
        label: '未确认',
        value: false
      }
    ],
    isShow: [
      {
        label: '显示',
        value: true
      },
      {
        label: '隐藏',
        value: false
      }
    ],
    isSelling: [
      {
        label: '上架',
        value: true
      },
      {
        label: '下架',
        value: false
      }
    ],
    isTop: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ],
    types: [
      {
        label: '输入框',
        value: 1
      },
      {
        label: '输入框(数字)',
        value: 2
      },
      {
        label: '文本域',
        value: 3
      },
      {
        label: '开关',
        value: 4
      },
      {
        label: '上传',
        value: 5
      }
    ],

    DELIVERYTYPES: [
      { label: '自提点', value: 2 },
      { label: '快递', value: 1 }
    ],

    ADFEE_TYPE: [{ label: '百度', value: 1 }, { label: '淘宝', value: 2 }, { label: '其他', value: 3 }],
    PAY_TYPE: [{ label: '支付宝', value: 0 }, { label: '微信', value: 1 }, { label: '淘宝', value: 2 }],
    ORDER_STATUS: [{ label: '待指派', value: 0 }, { label: '已指派', value: 1 }, { label: '进行中', value: 2 }, { label: '待支付', value: 3 }, { label: '已支付', value: 4 }, { label: '已分账', value: 5 }, { label: '已退单', value: 6 }],
    ORDER_STATUS_COLOR: ['orange', 'blue', 'red', 'default', 'cyan', 'purple', 'green', 'red'],

    ICON_TYPES: [],

    ICON_LINKS: [],
    AD_SLOTS: [],

    isInsertVideo: false
  },
  mutations: {
    SET_API_HOST (state, value) {
      state.api_host = value
    },
    SET_HOST (state, value) {
      state.host = value
    },
    SET_VERSION (state, value) {
      state.version = value
    },
    SET_ICON_TYPES (state, value) {
      state.ICON_TYPES = value
    },
    SET_ICON_LINKS (state, value) {
      state.ICON_LINKS = value
    },
    SET_AD_SLOTS (state, value) {
      state.adSlots = value
    },

    ON_INSERT_VIDEO (state, value) {
      state.isInsertVideo = value
    }
  },
  actions: {}
}

export default app
